import { IRolePermissionUpdate } from '@nx-fe/services';
import { ProfileType } from '../../../../modules/analytics-profiles/constants/constants';

export const ProfileWatchlistParamTypeEnum = { DATE: 'Date', NUMBER: 'Number', STRING: 'String', UNKNOWN: '' };

export type ProfileCollectionModes = 'standard' | 'battery-optimized' | 'accuracy-optimized';

export const ProfileWatchlistParamUnitEnum = {
  MEGABYTE: { display: 'Analysis_Profile_Form_MB', value: 'mb' },
  GIGABYTE: { display: 'Analysis_Profile_Form_GB', value: 'gb' },
  DAY: { display: 'Analysis_Profile_Form_Days', value: 'days' },
  HOURS: { display: 'Analysis_Profile_Form_Hours', value: 'hours' },
  PERCENTAGE: { display: 'Analysis_Profile_Form_Percent', value: '%' },
  ABSOLUTE: { display: 'Analysis_Profile_Form_Times', value: 'times' },
};

export const ProfileWatchlistParamOpEnum = {
  GREATER_THAN: '>',
  GREATER_THAN_OR_EQUAL_TO: '>=',
  LESS_THAN: '<',
  LESS_THAN_OR_EQUAL_TO: '<=',
  EQUAL_TO: '=',
  NOT_EQUAL_TO: '!=',
};

export class AnalyticsProfileWatchlistMetric {
  name: string;
  thresholdUnit: string;
  thresholdValue: string | number;
  enabled: boolean;

  public constructor(metric?: AnalyticsProfileWatchlistMetric) {
    if (metric) {
      this.name = metric.name;
      this.thresholdUnit = metric.thresholdUnit;
      this.thresholdValue = metric.thresholdValue;
      this.enabled = !!metric.enabled;
    } else {
      this.enabled = false;
    }
  }
}

export class AnalyticsProfileCollectionSettings {
  collectionMode: ProfileCollectionModes = 'standard';
  dataDeliveryInterval: number = 3;
  dataDeliveryWindowSize: number = 1;
  dataUpload: {
    cellular: boolean;
    cellularWhileRoaming: boolean;
  } = {
    cellular: false,
    cellularWhileRoaming: false,
  };

  public constructor(settings?: AnalyticsProfileCollectionSettings) {
    if (settings) {
      this.collectionMode = settings.collectionMode;
      this.dataDeliveryInterval = settings.dataDeliveryInterval;
      this.dataDeliveryWindowSize = settings.dataDeliveryWindowSize;
      this.dataUpload.cellular = !settings.dataUpload ? !!settings.dataUpload.cellular : false;
      this.dataUpload.cellularWhileRoaming = !settings.dataUpload ? !!settings.dataUpload.cellularWhileRoaming : false;
    }
  }
}

/**
 * Profile metadata, used in displaying list of profiles
 */
export class Profile {
  id: number | null;
  name: string;
  description: string;
  mcInstanceId: number;
  isActive: boolean;
  hasGroups: boolean;
  osId: number;
  isVisible: boolean;
}

export class ProfileConfiguration {
  id: number | null;
  name: string;
  description: string;
  isActive: boolean;
  mcInstanceId: number;
  deviceGroupIds: number[];
  deviceGroupIdsSet: Set<number>;
  collectionSettings: AnalyticsProfileCollectionSettings;
  osId: number;
  rolePermissions: Array<IRolePermissionUpdate>;
  isVisible: boolean;

  public constructor(model?: ProfileConfiguration) {
    if (model) {
      this.id = model.id || null;
      this.name = model.name;
      this.description = model.description;
      this.isActive = model.isActive;
      this.collectionSettings = new AnalyticsProfileCollectionSettings(model.collectionSettings);
      this.deviceGroupIds = model.deviceGroupIds;
      this.deviceGroupIdsSet = new Set(this.deviceGroupIds);
      this.osId = model.osId;
      this.rolePermissions = model.rolePermissions;
    } else {
      this.id = null;
      this.isActive = true;
      this.collectionSettings = new AnalyticsProfileCollectionSettings();
      this.rolePermissions = [];
      this.deviceGroupIdsSet = new Set();
    }
  }
}

export class McInstance {
  mcInstanceId: number;
  mcInstanceName: string;
}

export class McGroup {
  groupId: number;
  mcInstanceId: number;
  profileId: number;
  name: string;
  path: string;
  isDisabled: boolean;
  hasGroupAccess: boolean;
  isProfileEnabled: boolean;
}

export class UtilizationStore {
  StoreId: number;
  StoreName: string;
}

export class ProfileOs {
  osId: number;
  name: string;
  iconSrc: string;
}

export class UnifiedProfile {
  id: number;
  type: ProfileType;
  name: string;
  isActive?: boolean;
  hasGroups?: boolean;
  isVisible?: boolean;
}
